export default "__VITE_ASSET__BpCkgmFs__"